import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Divider,
  Alert,
  Tooltip,
} from '@mui/material';
import {
  Close as CloseIcon,
  CheckCircle as SuccessIcon,
  Info as InfoIcon,
  Error as ErrorIcon,
  Notifications as NotificationsIcon,
} from '@mui/icons-material';

const typeIcon = {
  success: <SuccessIcon color="success" />,
  info: <InfoIcon color="info" />,
  error: <ErrorIcon color="error" />,
  default: <NotificationsIcon color="primary" />,
};

function NotificationsPage({ notifications = [], onClose }) {
  return (
    <Box sx={{
      width: '100%', height: '100vh', p: 3, boxSizing: 'border-box', bgcolor: 'background.paper',
    }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Notifications
        </Typography>
        <Tooltip title="Close">
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Divider sx={{ mb: 2 }} />
      {notifications.length === 0 ? (
        <Alert severity="info">No notifications.</Alert>
      ) : (
        <List>
          {notifications.map((n) => (
            <React.Fragment key={n.id}>
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: 'transparent' }}>
                    {typeIcon[n.type] || typeIcon.default}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={n.title}
                  secondary={(
                    <>
                      <Typography component="span" variant="body2" color="text.primary">
                        {n.message}
                      </Typography>
                      <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                        {n.time}
                      </Typography>
                    </>
                )}
                />
              </ListItem>
              <Divider component="li" />
            </React.Fragment>
          ))}
        </List>
      )}
    </Box>
  );
}

export default NotificationsPage;
